import { queryOptions } from "@tanstack/react-query";
import { axiosClient } from "auth-sdk";
import type { UserDataSchemas } from "api-types";

const USER_DATA_API = "/api/:customerSlug/user-data/api/data";

export const getUserDataQueryOptions = (customerSlug: string) => {
  const url = USER_DATA_API.replace(":customerSlug", customerSlug);
  return queryOptions({
    queryKey: [url],
    queryFn: (): Promise<UserDataSchemas.UserData> =>
      axiosClient.get<UserDataSchemas.UserData>(url).then(({ data }) => data),
  });
};
